import React from 'react';

import { setCarouselHeight } from '../../../shared/components/carousel';
import AccessoriesCarousel from '../pdp-acc-carousel';
import CategorizedAccCarousel from '../pdp-cat-acc-carousel';

import '../../css/pdp-accessories.less';

const ACCESSORIES_LIST_METRIC = 'pdp-accessories';

class Accessories extends React.Component {

    constructor(props) {
        super(props);
        this.carousel = React.createRef();
    }

    componentDidUpdate(prevProps) {
        if(this.props.isActive && prevProps.isActive !== this.props.isActive && this.carousel) {
            setCarouselHeight(this.carousel.current);
        }
    }

    
    getCtaMetrics = () => ({ list: this.props.xsellType || 'pdp-accessories' })

    render() {
        const {product, xsellType} = this.props;
        const {sku} = product || {};
        const products = this.props.product.xsell.slice(0,4);
        const tabHeader = products.length > 0 ? 'Top matches for your product' :
        'No matching accessories found';
        const ctaMetrics = { list: xsellType || ACCESSORIES_LIST_METRIC };
        const productClickMetrics = {
            'data-metrics-list': ACCESSORIES_LIST_METRIC
        };
        return (
            <div className='pdp-acc'>
                <div className='pdp-tab-header'>{tabHeader}</div>
                <AccessoriesCarousel xsellType='pdp-accessories' baseProductSku={sku} 
                                     productClickMetrics={productClickMetrics} ctaMetrics={ctaMetrics} 
                                     products = { products } carouselRef={ this.carousel } setCarouselHeight={()=>setCarouselHeight(this.carousel.current)}/>
                {products.length > 0 && <CategorizedAccCarousel xsellType='pdp-accessories' baseProductSku={sku} isActive={ this.props.isActive } product={ this.props.product } productClickMetrics={productClickMetrics} ctaMetrics={ctaMetrics}/> }
            </div>
        )
    }

}

export default Accessories;
